import Swiper from "swiper";

class HomeSlider {
  constructor() {
    this.component = document.querySelector('[data-component="home-slider"]');
    this.trigger = document.querySelector('[data-trigger="home-slider"]');
    if (this.component) {
      this._init();
    }
  }

  _init() {
    if (this.component) {
      let swiper = null;

      // If swiper is init before image is loaded, we reload swiper
      // (when lazyload images with data-visibility)
      const firstImage = this.trigger.querySelector("img");
      if (firstImage) {
        firstImage.onload = () => {
          if (swiper) {
            swiper.update();
          }
        };
      }

      swiper = new Swiper(this.trigger, {
        slidesPerView: 3,
        navigation: {
          nextEl: ".slidenext",
          prevEl: ".slideprev"
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 20
          }
        }
      });
    }
  }
}

export const homeSlider = new HomeSlider();
